"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Types = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Messenger = _interopRequireDefault(require("../Messenger"));
var _excluded = ["max", "messengers", "vertical"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Types = exports.Types = _Messenger["default"].Types;
var MessengerList = exports["default"] = /*#__PURE__*/function (_React$PureComponent) {
  function MessengerList() {
    (0, _classCallCheck2["default"])(this, MessengerList);
    return _callSuper(this, MessengerList, arguments);
  }
  (0, _inherits2["default"])(MessengerList, _React$PureComponent);
  return (0, _createClass2["default"])(MessengerList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        max = _this$props.max,
        messengers = _this$props.messengers,
        vertical = _this$props.vertical,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var visibleMessengers = messengers.slice(0, max || messengers.length);
      var anotherMessengers = messengers.slice(max || messengers.length).join(', ');
      return /*#__PURE__*/_react["default"].createElement(StyledMessengers, props, visibleMessengers.map(function (messenger) {
        return /*#__PURE__*/_react["default"].createElement(StyledItem, {
          key: messenger,
          vertical: vertical || undefined
        }, /*#__PURE__*/_react["default"].createElement(_Messenger["default"], {
          type: messenger
        }));
      }), anotherMessengers && /*#__PURE__*/_react["default"].createElement(StyledAnotherMessengers, {
        title: anotherMessengers,
        vertical: vertical || undefined
      }, "..."));
    }
  }]);
}(_react["default"].PureComponent);
var MessengersType = _propTypes["default"].arrayOf(_propTypes["default"].oneOf(Object.values(Types)));
MessengerList.MessengersType = MessengersType;
MessengerList.propTypes = {
  className: _propTypes["default"].string,
  max: _propTypes["default"].number,
  messengers: MessengersType.isRequired,
  vertical: _propTypes["default"].bool
};
MessengerList.defaultProps = {
  className: '',
  max: 0,
  vertical: false
};
var StyledMessengers = _styledComponents["default"].ul.withConfig({
  displayName: "MessengerList__StyledMessengers",
  componentId: "sc-sr503o-0"
})(["overflow:hidden;"]);
var StyledItem = _styledComponents["default"].li.withConfig({
  displayName: "MessengerList__StyledItem",
  componentId: "sc-sr503o-1"
})(["float:left;& + &{margin-left:-16px;}", ""], function (props) {
  return props.vertical && "\n    float: none;\n    \n    & + & {\n      margin-left: 0;\n      margin-top: -16px;\n    }\n  ";
});
var StyledAnotherMessengers = _styledComponents["default"].li.withConfig({
  displayName: "MessengerList__StyledAnotherMessengers",
  componentId: "sc-sr503o-2"
})(["cursor:default;float:left;height:24px;padding:0 5px;user-select:none;", ""], function (props) {
  return props.vertical && "\n    float: none;\n    height: 15px;\n    line-height: 5px;\n    padding: 0;\n    text-align: center;\n    width: 24px;\n  ";
});